import { cx } from "@emotion/css";
import type { FC, ReactElement } from "react";

import HouseIcon from "@/assets/house.svg?react";
import NumberOfIcon from "@/assets/numberOf.svg?react";
import PlacePinIcon from "@/assets/place-pin.svg?react";
import { Card } from "@/components";
import type { LongTextVariant } from "@/components/text/LongText";
import LongText from "@/components/text/LongText";
import type { Property } from "@/types";

interface IControllerBuildingCardProps {
  className: string;
  titleLighted?: boolean;
  property: Property;
  onClick: () => void;
}
export default function ControllerBuildingCard({
  className,
  property,
  titleLighted,
  onClick,
}: Readonly<IControllerBuildingCardProps>) {
  const addressofBuildings = property?.buildings?.filter(
    (building) => "address" in building && building?.address && "full_address" in building.address
  ) as Array<{ address: { full_address: string } }>;

  const addressStrings = addressofBuildings?.map((building) => building.address.full_address);
  return (
    <Card className={cx("my-3", className)} onClick={onClick}>
      <p className={cx("text-lg font-semibold text-neutral-800", "mb-1.5", titleLighted && "text-primary")}>
        <LongText variant="multilineFull" text={property.name || ""} />
      </p>
      <PatmoBuildingCardItem
        attributeName="仮称名称"
        icon={<HouseIcon className="mb-[2px] mr-[10px] inline" />}
        content={property?.alias}
        style="line"
      />
      <PatmoBuildingCardItem
        attributeName="地番"
        icon={<NumberOfIcon className="mb-[2px] mr-[10px] inline" />}
        content={property.address?.full_address}
      />
      <PatmoBuildingCardItem
        attributeName="住所"
        icon={<PlacePinIcon className="mb-[2px] mr-[10px] inline" />}
        content={addressStrings}
      />
    </Card>
  );
}

interface IPatmoBuildingCardItemProps {
  attributeName: string;
  icon: ReactElement;
  content?: Array<string> | string | undefined | number;
  longTextVariant?: LongTextVariant;
  style?: "default" | "line";
}
const PatmoBuildingCardItem: FC<IPatmoBuildingCardItemProps> = ({
  attributeName,
  content,
  icon,
  longTextVariant = "multilineFull",
  style = "default",
}) => {
  const isArray = Array.isArray(content);
  const isLine = style === "line" && !isArray;

  if (isLine) {
    return (
      <div className={cx("text-sm text-neutral-600")}>
        <span>
          {icon}
          {attributeName}：
        </span>
        <span >
          {content || "-"}
        </span>
      </div>
    );
  }

  return (
    <div className={cx("flex items-start", "text-sm text-neutral-600")}>
      <span className="shrink-0">
        {icon}
        {attributeName}：
      </span>
      {!Array.isArray(content) && (
        <span className="min-w-0 flex-1">
          <LongText variant={longTextVariant} text={content || "-"} />
        </span>
      )}
      {Array.isArray(content) && (
        <div className="min-w-0 flex-1">
          {content?.map((item, index) => (
            <span className="block min-w-0 break-words hyphens-auto" key={index}>
              {item || "-"}
            </span>
          ))}
          {content?.length ? <></> : "-"}
        </div>
      )}
    </div>
  );
};
